<template>
  <offline-page :is-modal="true" :is-closeable="isCloseable" @close="handleClose"/>
</template>

<script>
  import OfflinePage from '../../pages/Offline.vue'
  import { defineComponent } from 'vue'

  export default defineComponent({
    props: {
      isCloseable: {
        type: Boolean,
        default: false // Make it not closeable by default since ecosystem is offline
      }
    },
    emits: ['close'],
    methods: {
      handleClose() {
        this.$emit('close')
      }
    },
    components: {
      OfflinePage,
    },
  })
</script>